import SearchList from "./components/SearchList.tsx";
import { usePageTitle } from "./hooks/usePageTitle.ts";

function TechSheets() {
  usePageTitle('Tech Sheets')
  return (
    <div
      id="ts-terrastation-wrapper"
      className="w-full h-full flex items-center justify-center"
    >
      <div
        id="ts-terrastation-content"
        className="w-full xl:w-2/3 p-4 h-full flex flex-col items-center"
      >
        <div className="w-full relative flex items-center justify-center text-2xl p-2 border-b border-light-border">
          Tech Sheets
        </div>

        <SearchList reqURL='/api/list/tech-sheets' />
      </div>
    </div>
  );
}

export default TechSheets;
